import { Component } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";

import { Resource } from "@impulse/sdp-shared-models";

import { ApplicationWizardService } from "../application-wizard.service";
import { ValidationService } from "../../../../common/validation/validation.service";
import { ApplicationWizardSelectType } from "../models";
import { ApplicationsService } from "../../applications.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { ApplicationWebUrlComponent } from "../application-web-url/application-web-url.component";
import { ApplicationNetworkServiceComponent } from "../application-network-service/application-network-service.component";


@Component({
	templateUrl: "./application-select-type.component.html"
})
export class ApplicationSelectTypeComponent extends AbstractWizardStepComponent<void> {
	public form: FormGroup;

	constructor(
		private service: ApplicationWizardService,
		private formBuilder: FormBuilder,
		private validationService: ValidationService,
		private applicationService: ApplicationsService
	) {
		super();

		const applications: Resource[] = [];
		this.form = this.formBuilder.group({
			name: [
				this.service.getValue("name", ""),
				Validators.compose([
					Validators.required,
					this.validationService.duplicate(applications, "name"),
					Validators.pattern("^[a-zA-Z0-9_ -]+$"),
				])
			],
			selectType: [
				this.service.getValue("selectType", ""),
				Validators.compose([
					Validators.required
				])
			],
		});

		this.applicationService.getData()
			.then((applicationsFromService) => {
				// load the array that we will do duplicate checks against with the data from the service
				// only keep those elements that aren't this one
				// for creates we don't need to exclude anything
				// for updates we want to ignore the original element that is being edited
				// this lets us continue to keep this array up to date even if we navigate away from this step and come back
				if (!!this.service.applicationState.applicationBeingEdited) {
					for (const app of applicationsFromService) {
						if (app.name !== this.service.applicationState.applicationBeingEdited.name) {
							applications.push(app);
						}
					}
				}
			})
			.catch((error) => {
				// TODO error handling
			});
	}

	public get title() {
		return this.service.applicationState.isCreate ?
			"application.wizard.title.create" : "application.wizard.title.update";
	}

	public get description() {
		return "application.wizard.selectType.description";
	}

	public get nextStep() {
		if (this.selectType.selectType === "website") {
			return ApplicationWebUrlComponent;
		} else {
			return ApplicationNetworkServiceComponent;
		}
	}

	public get previousStep(): AbstractWizardStepComponent.ConstructorFunction<void> | undefined {
		return undefined;
	}

	public get isFormValid() {
		return this.form.valid;
	}

	public performPrevious() {
		this.service.processSelectType(this.selectType);
	}

	public performNext() {
		this.service.processSelectType(this.selectType);
	}

	public get showProgressBar() {
		return false;
	}

	private get selectType(): ApplicationWizardSelectType {
		return this.form.getRawValue();
	}
}
